import React from 'react';
import { cn } from '../../../ui';
import { clampPct } from '../studentHomeRules';

const RING_STROKE_CLASSES = {
  primary: 'tw-stroke-primary',
  emerald: 'tw-stroke-success',
  amber: 'tw-stroke-warning',
  rose: 'tw-stroke-danger',
};

/**
 * A score as a ring, with the words for it in the middle. `pathLength` makes the
 * dash read as a percentage, and the colours are classes because a CSS `stroke`
 * resolves a token where an SVG attribute may not.
 */
const ScoreRing = ({ score, tone = 'primary', label, className, children }) => (
  <div role="img" aria-label={label} className={cn('tw-relative tw-shrink-0', className)}>
    <svg viewBox="0 0 36 36" className="tw-block tw-h-full tw-w-full tw--rotate-90" aria-hidden="true">
      <circle cx="18" cy="18" r="15.9" fill="none" strokeWidth="3" className="tw-stroke-primary/10" />
      <circle
        cx="18"
        cy="18"
        r="15.9"
        fill="none"
        strokeWidth="3"
        strokeLinecap="round"
        pathLength="100"
        strokeDasharray={`${clampPct(score)} 100`}
        className={RING_STROKE_CLASSES[tone] || RING_STROKE_CLASSES.primary}
      />
    </svg>
    <div className="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center">
      {children}
    </div>
  </div>
);

export default ScoreRing;
